export const GET_COACHES = "GET_COACHES";
export const GET_COACH_BY_ID = "GET_COACH_BY_ID";
export const UPDATE_COACH = "UPDATE_COACH";
export const DELETE_COACH = "DELETE_COACH";
export const CREATE_COACH = "CREATE_COACH";
export const GET_COACH_PUBLIC_AVAILABILITIES =
  "GET_COACH_PUBLIC_AVAILABILITIES";
export const GET_DAILY_AVAILABILITIES = "GET_DAILY_AVAILABILITIES";
